/**
 * Reduces an error, usually an axios error, to its message and HTTP status before it is kept in
 * state. An axios error carries its request config, which holds the `Authorization` header with the
 * session id and a URL that can hold the user's id, and the response body. Anything that later logs
 * or reports the kept error would send all of that with it.
 */
export default function toSafeError(error) {
  const safeError = new Error(error?.message || 'Request failed')
  safeError.status = error?.response?.status ?? error?.status
  return safeError
}
